module.exports = __webpack_public_path__ + "img/eye.d562fca9.svg";